import { lazy } from "react";
import { RouterItemType } from "@/app/index";

const LayoutPageOrders = lazy(() => import("./layout/index"));

export const routerPageOrders: RouterItemType = {
  path: "/billing/orders",
  authorize: true,
  element: <LayoutPageOrders />,
};
